import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setAdverts, setLoading, setSingleAdvert } from "../../repository/slice";

function* getSingleAdvertWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/announcement/get/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleAdvert(data));
        }
    } catch (error) {
        console.error("getSingleAdvertWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleAdvertWatcher() {
    yield takeLatest("@saga/GET_SINGLE_ADVERT", getSingleAdvertWorker);
};
